module.exports = __webpack_public_path__ + "img/payment-print-badge.f85247c8.png";